import Vue from "vue";

export default function emptyFetchStateFactory(): Vue["$fetchState"] {
  return {
    pending: false,
    timestamp: 0,
    error: null,
  };
}
